(() => {
  if (window.coverlyViewerTheme) return;
  window.coverlyViewerTheme = true;
  const viewerOrigin = 'https://p.prettyproductoptions.com';
  function themeFromPage() {
    const style = getComputedStyle(document.body);
    const fontFamily = style.getPropertyValue('--font-body-family').trim() || style.fontFamily;
    const fontFaces = [];
    function walk(rules, base) {
      for (const rule of rules) {
        if (rule.type === CSSRule.FONT_FACE_RULE) {
          const face = rule.style;
          const family = face.getPropertyValue('font-family').replace(/^["']|["']$/g, '');
          if (!fontFamily.toLowerCase().includes(family.toLowerCase())) continue;
          const src = face.getPropertyValue('src').replace(/url\(["']?([^"')]+)["']?\)/g, (_, path) => 'url("' + new URL(path, base || document.baseURI).href + '")');
          fontFaces.push({family, src, weight: face.getPropertyValue('font-weight') || 'normal', style: face.getPropertyValue('font-style') || 'normal'});
        } else if (rule.cssRules) walk(rule.cssRules, base);
      }
    }
    for (const sheet of document.styleSheets) {
      try { walk(sheet.cssRules, sheet.href); } catch { /* Cross-origin sheets may be unreadable; the viewer has Oswald. */ }
    }
    return {fontFamily, fontFaces};
  }
  window.addEventListener('message', event => {
    if (event.origin !== viewerOrigin || event.data?.type !== 'coverly:theme-ready') return;
    const frame = Array.from(document.querySelectorAll('iframe')).find(candidate => candidate.contentWindow === event.source);
    if (!frame) return;
    const url = new URL(frame.src, document.baseURI);
    if (url.origin !== viewerOrigin || !url.pathname.startsWith('/visualizer/shutters/')) return;
    event.source.postMessage({type: 'coverly:theme', theme: themeFromPage()}, event.origin);
  });
})();
